import {Grid2, Typography} from "@mui/material";
import * as React from "react";
import {Section6DTO} from "@/pages/landing-page/landing-page-data";
import {NetworkSvg, VectorSvg} from "@/pages/landing-page/utils/Svgs";
import {LANDING_HEADLINE, LANDING_LEAD} from "@/pages/landing-page/utils/landing-font-sizes";
import {COMPACT_SECTION_MIN_HEIGHT} from "@/pages/landing-page/utils/landing-section-layout";

interface Section6Props {
    data: Section6DTO;
}

export const Section6 = ({ data }: Section6Props) => (
    <Grid2
        container
        direction="column"
        paddingTop={4}
        // px={20}
        width="100%"
        sx={{
            minHeight: COMPACT_SECTION_MIN_HEIGHT,
            // backgroundColor: color_grey[4],
            position: "relative",
            px: {
                md: 1,
                lg: 10
            }
        }}
    >
        <VectorSvg style={{ position: "absolute", top: 0, left: 1300, zIndex: 0, transform: "translateZ(0)" }} />
        <VectorSvg style={{ position: "absolute", bottom: 200, left: 100, zIndex: 0, transform: "translateZ(0)" }} />

        <Grid2 maxWidth="100%">
            <Typography sx={{ fontSize: LANDING_HEADLINE }} fontWeight="700">
                {data.title}
            </Typography>
        </Grid2>
        <Grid2 container direction="row" gap={{ xs: 4, lg: 12 }}>
            <Grid2>
                <Grid2 paddingTop={{ xs: 4, lg: 20 }} maxWidth="580px">
                    <Typography sx={{ fontSize: LANDING_LEAD }}>{data.text}</Typography>
                </Grid2>
            </Grid2>
            {/* Below `lg` text and graphic do not fit side by side: the graphic takes the section width up to its own
                580 px below the text, and its height follows the `viewBox`. */}
            <Grid2
                data-cy="network-graphic"
                paddingTop={0}
                sx={{
                    width: { xs: "min(580px, 100%)", lg: "auto" },
                    marginTop: { xs: 0, lg: -8 },
                    "& > svg": { height: { xs: "auto", lg: "773px" } }
                }}
            >
                <NetworkSvg width="100%" />
            </Grid2>
        </Grid2>
    </Grid2>
);
